var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Action/Filtrer/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5621,6 L11.1221,12.255 C11.2851,12.437 11.3751,12.674 11.3751,12.919 L11.3751,17.692 L12.6231,16.86 L12.6231,12.919 C12.6231,12.674 12.7131,12.437 12.8761,12.255 L18.4351,6 L5.5621,6 Z M10.9161,20.092 C10.6671,20.092 10.4171,20.031 10.1881,19.909 C9.6861,19.641 9.3751,19.119 9.3751,18.55 L9.3751,13.299 L3.3901,6.565 C2.9861,6.112 2.8871,5.463 3.1351,4.91 C3.3841,4.357 3.9351,4 4.5421,4 L19.4561,4 C20.0621,4 20.6141,4.357 20.8631,4.91 C21.1111,5.463 21.0121,6.112 20.6091,6.565 L14.6231,13.299 L14.6231,17.105 C14.6231,17.623 14.3661,18.104 13.9351,18.39 L11.7711,19.832 C11.5131,20.005 11.2151,20.092 10.9161,20.092 L10.9161,20.092 Z",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlack);
export default __webpack_public_path__ + "static/media/filter_black.8e42fe4ef3c2899f17bff8dcd001da2b.svg";
export { ForwardRef as ReactComponent };